import { StepType } from "../classes/step";

export const defaultDataArgs: StepType[] = [];

async function getWorksiteOptions() {
    // @ts-ignore
    const response = await fetch(`${window.ergmapsScriptsObject.ajaxUrl}?action=get_available_worksites`);
    const responseJson = await response.json();
    const options = [];

    for (let i = 0; i < responseJson.length; i++) {
        options.push({ title: responseJson[i].value, value: responseJson[i].value });
    }

    return options;
}

export async function initializeDefaultDataArgs(): Promise<StepType[]> {
    const worksiteOptions = await getWorksiteOptions();

    defaultDataArgs.push(
        {
            title: "Step 1",
            desc: "Is this report about worksites or people?",
            name: "typeOfReport",
            type: "radio",
            options: [{ title: "Worksites", value: "worksites" }, { title: "People", value: "people" }],
            values: [],
        },
        {
            title: "Step 2",
            desc: "Which worksites are you interested in gathering data on?",
            name: "worksites",
            type: "multiSelect",
            options: worksiteOptions,
            values: [],
        },
        {
            title: "Step 3",
            desc: "What type of data are you looking for?",
            name: "dataType",
            type: "select",
            options: [
                { title: "Concern", value: "concern", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }]] },
                { title: "Discomfort", value: "discomfort" },
                { title: "Job Status", value: "job_status" },
                { title: "Logins", value: "logins", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }]] },
                { title: "Raw Data", value: "raw_data", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                { title: "Raw Data - Follow Up", value: "raw_data_follow_up", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                { title: "Recommendations", value: "recommendations", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                { title: "Usage", value: "usage" },
            ],
            values: [],
        },
        {
            title: "Step 4",
            desc: "What timeframe would you like to see for this data?",
            name: "timeframe",
            type: "select",
            options: [
                { title: "This week", value: "this_week" },
                { title: "This month", value: "this_month" },
                { title: "This quarter", value: "this_quarter" },
                { title: "This year", value: "this_year" },
                { title: "Last week", value: "last_week" },
                { title: "Last month", value: "last_month" },
                { title: "Last quarter", value: "last_quarter" },
                { title: "Last year", value: "last_year" },
                { title: "Custom", value: "custom" },
            ],
            values: [],
            customFields: [
                {
                    option: "custom",
                    type: "datePicker",
                },
            ],
        },
        {
            title: "Step 5",
            desc: "What columns would you like to see and in what order?",
            name: "columns",
            type: "multiSelect",
            options: [
                {
                    title: "Case#", value: "case_number", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "recommendations" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "job_status" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                { title: "First Name", value: "first_name", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                { title: "Last Name", value: "last_name", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                {
                    title: "Date of Initial", value: "date_of_initial", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "recommendations" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "job_status" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Date of Follow up", value: "date_of_follow_up", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                { title: "Worksite", value: "worksite" },
                { title: "Count of Initial", value: "initial_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Count of Follow Up", value: "follow_up_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Count of Home (Initial)", value: "home_initial_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Count of Home (Follow Up)", value: "home_follow_up_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Count of Office (Initial)", value: "office_initial_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Count of Office (Follow Up)", value: "office_follow_up_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Count of Hoteling (Initial)", value: "hoteling_initial_evaluation_count", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Email", value: "email", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                { title: "Phone", value: "phone", displayIf: [[{ stepName: "typeOfReport", value: "people" }]] },
                { title: "Number of Logins", value: "number_of_logins", displayIf: [[{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Number of SAFEs", value: "number_of_safes", displayIf: [[{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Number of Items Ordered", value: "number_of_items_ordered", displayIf: [[{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "usage" }]] },
                { title: "Number of Ergonomist Evaluations", value: "number_of_ergonomist_evaluations", displayIf: [[{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "usage" }]] },
                { title: "List Recommendations", value: "list_recommendations", displayIf: [[{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "recommendations" }]] },
                { title: "Current Job Status", value: "current_job_status", displayIf: [[{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "job_status" }]] },
                { title: "Count of Logins", value: "count_of_logins", displayIf: [[{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "logins" }]] },

                // { title: "Any Body Part", value: "any_body_part" },
                {
                    title: "Type of SAFE", value: "type_of_safe", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Head", value: "head", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Eyes", value: "eyes", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Neck", value: "neck", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Right Shoulder", value: "rshoulder", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Left Shoulder", value: "lshoulder", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Back", value: "back", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Legs", value: "legs", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Right Forearm", value: "rforearm", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Left Forearm", value: "lforearm", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Right Elbow", value: "relbow", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Left Elbow", value: "lelbow", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Right Wrist", value: "rhand", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Left Wrist", value: "lhand", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "discomfort" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }],
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Adjust Your Workstation", value: "adjust_your_workstation", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Require Additional Assistance", value: "require_additional_assistance", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Would You Recommend", value: "would_you_recommend", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Your Safe Experience", value: "your_safe_experience", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data_follow_up" }]
                    ]
                },
                {
                    title: "Avg Head", value: "avg_head", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Neck", value: "avg_neck", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Eyes", value: "avg_eyes", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Right Shoulder", value: "avg_right_shoulder", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Left Shoulder", value: "avg_left_shoulder", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Back", value: "avg_back", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Legs", value: "avg_legs", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Right Elbow", value: "avg_right_elbow", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Left Elbow", value: "avg_left_elbow", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Right Forearm", value: "avg_right_forearm", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Left Forearm", value: "avg_left_forearm", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Right Wrist", value: "avg_right_wrist", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },
                {
                    title: "Avg Left Wrist", value: "avg_left_wrist", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "discomfort" }]
                    ]
                },

                {
                    title: "Count Head", value: "count_head", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Neck", value: "count_neck", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Eyes", value: "count_eyes", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Right Shoulder", value: "count_right_shoulder", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Left Shoulder", value: "count_left_shoulder", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Back", value: "count_back", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Legs", value: "count_legs", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Right Elbow", value: "count_right_elbow", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Left Elbow", value: "count_left_elbow", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Right Forearm", value: "count_right_forearm", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Left Forearm", value: "count_left_forearm", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Right Wrist", value: "count_right_wrist", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },
                {
                    title: "Count Left Wrist", value: "count_left_wrist", displayIf: [
                        [{ stepName: "typeOfReport", value: "worksites" }, { stepName: "dataType", value: "concern" }]
                    ]
                },

                /* ---------- SEATING ---------- */
                {
                    title: "Seating 1", value: "seating_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Seating 2", value: "seating_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Seating 3", value: "seating_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Seating 4", value: "seating_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Seating 5", value: "seating_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Seating 6", value: "seating_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Seating 7", value: "seating_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /SEATING ---------- */

                /* ---------- KEYBOARD ---------- */
                {
                    title: "Keyboard 1", value: "keyboard_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Keyboard 2", value: "keyboard_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Keyboard 3", value: "keyboard_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Keyboard 4", value: "keyboard_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Keyboard 5", value: "keyboard_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Keyboard 6", value: "keyboard_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Keyboard 7", value: "keyboard_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /KEYBOARD ---------- */

                /* ---------- MONITOR ---------- */
                {
                    title: "Monitor 1", value: "monitor_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Monitor 2", value: "monitor_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Monitor 3", value: "monitor_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Monitor 4", value: "monitor_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Monitor 5", value: "monitor_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Monitor 6", value: "monitor_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Monitor 7", value: "monitor_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /MONITOR ---------- */

                /* ---------- WORKSPACE CLEARANCES ---------- */
                {
                    title: "Workspace clearances 1", value: "workspace_clearances_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Workspace clearances 2", value: "workspace_clearances_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Workspace clearances 3", value: "workspace_clearances_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Workspace clearances 4", value: "workspace_clearances_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Workspace clearances 5", value: "workspace_clearances_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Workspace clearances 6", value: "workspace_clearances_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Workspace clearances 7", value: "workspace_clearances_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /WORKSPACE CLEARANCES ---------- */

                /* ---------- WORK SURFACES ---------- */
                {
                    title: "Work surfaces 1", value: "work_surfaces_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Work surfaces 2", value: "work_surfaces_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Work surfaces 3", value: "work_surfaces_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Work surfaces 4", value: "work_surfaces_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Work surfaces 5", value: "work_surfaces_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Work surfaces 6", value: "work_surfaces_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Work surfaces 7", value: "work_surfaces_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /WORK SURFACES ---------- */

                /* ---------- PHONE ---------- */
                {
                    title: "Phone 1", value: "phone_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Phone 2", value: "phone_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Phone 3", value: "phone_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Phone 4", value: "phone_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Phone 5", value: "phone_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Phone 6", value: "phone_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Phone 7", value: "phone_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /PHONE ---------- */

                /* ---------- LIGHTING ---------- */
                {
                    title: "Lighting 1", value: "lighting_1", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Lighting 2", value: "lighting_2", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Lighting 3", value: "lighting_3", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Lighting 4", value: "lighting_4", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Lighting 5", value: "lighting_5", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Lighting 6", value: "lighting_6", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                {
                    title: "Lighting 7", value: "lighting_7", displayIf: [
                        [{ stepName: "typeOfReport", value: "people" }, { stepName: "dataType", value: "raw_data" }]
                    ]
                },
                /* ---------- /LIGHTING ---------- */
            ],
            values: [],
            customFields: [
                // {
                //     option: "any_body_part",
                //     type: "bodyPartValuePicker",
                // },
                {
                    option: "head",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "eyes",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "neck",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "rshoulder",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "lshoulder",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "back",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "legs",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "rforearm",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "lforearm",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "relbow",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "lelbow",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "rhand",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "lhand",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_head",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_neck",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_eyes",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_right_shoulder",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_left_shoulder",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_back",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_legs",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_right_elbow",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_left_elbow",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_right_forearm",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_left_forearm",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_right_wrist",
                    type: "bodyPartValuePicker",
                },
                {
                    option: "count_left_wrist",
                    type: "bodyPartValuePicker",
                },
            ],
        },
        // {
        //     title: "Step 6",
        //     desc: "How would you like to see your data visualization?",
        //     name: "visualization",
        //     type: "select",
        //     options: ["Chart", "Bar Chart", "Pie Chart", "Line Graph"],
        //     values: [],
        // },
    );

    return defaultDataArgs;
}
